// actions/museum.ts — M2
import { defineAction } from '../define';
import { g } from '../guard';
import type { ItemId } from '../../types/ids';
import type { ItemView } from '../../types/items';
import type { MuseumEntryView } from '../../types/museum';
declare module '../registry' {
  interface ActionMap {
    'museum.identify': { req: { items: ItemId[] }; res: { items: ItemView[] } };
    'museum.donate': { req: { item: ItemId }; res: { entry: MuseumEntryView; hallComplete: 'fossils' | 'fish' | null } };
  }
}
export const museumIdentify = defineAction('museum.identify', g.obj({ items: g.arr(g.id<ItemId>('i'), 99) }));
export const museumDonate = defineAction('museum.donate', g.obj({ item: g.id<ItemId>('i') }));
